import React, { useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../common";
import { useAuth } from "../helpers/AuthContext"; // <-- import your auth hook
import { FaArrowLeft } from "react-icons/fa";
const StudentOtp = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth(); // <-- get login function

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 3) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const enteredOtp = otp.join("");

  const identifier = localStorage.getItem("student_identifier");

  if (!identifier) {
    toast.error("No identifier found. Please go back and enter your email.");
    return;
  }

  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);

  if (!enteredOtp || enteredOtp.length < 4) {
    toast.error("Please enter the complete OTP.");
    return;
  }

  setIsLoading(true); // Start loading

  const requestBody = {
    otp: enteredOtp,
    ...(isEmail ? { email: identifier } : { mobile_number: identifier }),
  };

  try {
    const response = await fetch(SummaryApi.StudentOtpVerification.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    if (data.status === true) {
      toast.success("OTP verified successfully!");

      localStorage.setItem("verified_identifier", identifier);
      localStorage.setItem("student_id", data.student_id);
      localStorage.setItem("student", JSON.stringify(data));

      // Use login to set studentId and name globally and sessionStorage
      login(data.student_id, data.student_first_name); // Assuming data.student_first_name exists

      console.log("Global studentId set:", data.student_id);

      // ONLY CHANGE: Increased timeout from 1500 to 3000
      setTimeout(() => {
        if (data.college_id === 0) {
          navigate("/");
        } else {
          navigate("/student-panel/category-selection");
        }
      }, 3000); // Changed from 1500 to 3000
    } else {
      toast.error(data.message || "OTP verification failed.");
    }
  } catch (error) {
    console.error("OTP verification error:", error);
    toast.error("Something went wrong. Please try again.");
  } finally {
    setIsLoading(false); // Stop loading in all cases
  }
};
  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center">
              <button
          onClick={() => window.history.back()}
          className="fixed top-10 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700 "
          aria-label="Go back"
        >
          <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
        </button>
    
      <div className="w-full max-w-7xl min-h-[650px] flex rounded-3xl overflow-hidden shadow-lg">
        {/* Left Side - Background with logo */}
        <div className="w-1/2 relative">
          <img
            src={loginbg}
            alt="Instructor Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            <img src={logo} alt="Logo" className="w-64" />
          </div>
        </div>

        {/* Right Side - OTP Form */}
        <div className="w-1/2 bg-white flex items-start justify-center pt-12 px-10">
          <div className="w-full max-w-md">
            <h2 className="text-[36px] font-bold text-blue-900 mb-10 text-center font-inter">
              Verify OTP
            </h2>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* OTP Inputs */}
              <div>
                <label
                  htmlFor="otp"
                  className="block text-sm font-medium text-gray-700 font-inter mb-1"
                >
                  Enter OTP
                </label>
                <div className="flex justify-between gap-4">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputsRef.current[index] = el)}
                      className="w-14 h-16 text-center text-2xl border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                  ))}
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isLoading} // Disable button when loading
                className={`w-full py-3 ${
                  isLoading ? 'bg-blue-700' : 'bg-blue-900 hover:bg-blue-800'
                } text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter mt-6 flex items-center justify-center`}
              >
                {isLoading ? (
                  <>
                    <svg 
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" 
                      xmlns="http://www.w3.org/2000/svg" 
                      fill="none" 
                      viewBox="0 0 24 24"
                    >
                      <circle 
                        className="opacity-25" 
                        cx="12" 
                        cy="12" 
                        r="10" 
                        stroke="currentColor" 
                        strokeWidth="4"
                      ></circle>
                      <path 
                        className="opacity-75" 
                        fill="currentColor" 
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Verifying...
                  </>
                ) : (
                  "VERIFY OTP"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

          <ToastContainer 
      position="top-center"
      autoClose={1500}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />




    </div>














  );
};

export default StudentOtp;
